import { LocalStorageService } from '@src/app/core/services';
import { Directive, Input, ElementRef, Renderer2, OnDestroy, OnInit } from '@angular/core';
import { TranslateConfigService } from '@src/app/core/services/translate-config.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { TranslationChangeService } from '../../services/translation-change.service';
import { HttpClient } from '@angular/common/http';

@Directive({
  selector: '[translateIt]',
})
export class TranslateDirective implements OnInit, OnDestroy {
  @Input('translateIt') textToAdd: string | object = ''; // it can be object as well so we can handle multiple things here, in case of object the "key" in langague file should be placed under "key"
  private subscription: Subscription | undefined;
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private configService: TranslateConfigService,
    private translationChangeService: TranslationChangeService,
    private httpClient: HttpClient,
    private localStorageService: LocalStorageService,
  ) {}

  ngOnInit() {
    this.subscription = this.translationChangeService.language$.subscribe(language => {
      // Implement logic to update translations based on the selected language
      // For example, you can call a translation function or update a property.
      //   console.log('Language changed to', language);
      this.translate();
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  private translate() {
    // 1: look for current language in localstorage
    const storedLanguage = this.localStorageService.get('language');
    const parsedLanguage = storedLanguage ? storedLanguage : { code: 'en' };
    const langcode = parsedLanguage.code;

    // let langcode = 'en';

    // 2: look for current language path created based on configService
    let jsonPath = this.configService.getPath() + langcode + '.json'; // full path of json file

    // logic for checking if its a subdomain language key then change the path to file added subdomain
    if (this.isSubDomain()) {
      // if its a subdomain
      jsonPath = this.configService.getPath() + 'subdomain/' + langcode + '.json';
    }

    // Calling file | session to get translation object
    if (this.localStorageService.get('languageOptimization') && !this.isSubDomain()) {
      // we have language file in session and we are looking for main domain
      let optimzedLangObj1 = this.localStorageService.get('languageOptimization');
      // let optimzedLangObj = JSON.parse(optimzedLangObj1 ?? '');
      let optimzedLangObj = optimzedLangObj1;

      if (optimzedLangObj.path === jsonPath) {
        this.getTranslationFromSession(optimzedLangObj.languagedata); // we already have its json in session
      } else {
        this.getTranslationFromFile(jsonPath); // we dont have its json in session (file we have is for another page) so call http
      }
    } else if (this.localStorageService.get('subLanguageOptimization') && this.isSubDomain()) {
      // we have language file in session for subdomain
      let optimzedLangObj1 = this.localStorageService.get('subLanguageOptimization');
      // let optimzedLangObj = JSON.parse(optimzedLangObj1 ?? '');
      let optimzedLangObj = optimzedLangObj1;

      if (optimzedLangObj.path === jsonPath) {
        this.getTranslationFromSession(optimzedLangObj.languagedata); // we already have its json in session
      } else {
        this.getTranslationFromFile(jsonPath); // we dont have its json in session (file we have is for another page) so call http
      }
    } else {
      this.getTranslationFromFile(jsonPath); // we dont have language file in session
    }
  }

  private isSubDomain() {
    // textToAdd is object and it have boolean subdomain = true then look for subdomain file
    if (typeof this.textToAdd === 'object' && 'subdomain' in this.textToAdd) {
      return this.textToAdd['subdomain'] === true;
    }
    return false;
  }

  private getTranslationKey() {
    // get key used in json file passed through directive
    return typeof this.textToAdd !== 'string'
      ? (this.textToAdd as { key: string })['key']
      : this.textToAdd;
  }

  private getTranslationFromSession(sessionLanguageData: any) {
    let langValue = sessionLanguageData[this.getTranslationKey()];
    let translatedtext = langValue ?? this.textToAdd; // check for value otherwise just return the key if key value doesnt exsist
    this.appendText(translatedtext);
  }

  private getTranslationFromFile(jsonPath: string) {
    this.httpClient.get(jsonPath).subscribe({
      next: (translationData: any) => {
        if (this.isSubDomain()) {
          this.localStorageService.set({
            key: 'subLanguageOptimization',
            value: { path: jsonPath, languagedata: translationData },
          });
        } else {
          this.localStorageService.set({
            key: 'languageOptimization',
            value: { path: jsonPath, languagedata: translationData },
          });
        }
        let translatedtext = translationData[this.getTranslationKey()] ?? this.textToAdd;
        this.appendText(translatedtext);
      },
      error: error => {
        console.error('Error fetching translation data:', error);
      },
    });
  }

  private appendText(textToReplace: string) {
    // const textNode = this.renderer.createText(textToReplace); // creating node for string to append it
    console.log('Directive append text called');
    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', textToReplace); // Replaced
  }
}
